import React from 'react';

const ArrowDownLineIcon = ({ style }: { style?: React.CSSProperties }) => {
    return (
        <svg
            style={style}
            viewBox="0 0 24 24"
            fill="currentColor"
            width="1em"
            height="1em"
        >
            <path d="M12 15.0006L7.75732 10.758L9.17154 9.34375L12 12.1722L14.8284 9.34375L16.2426 10.758L12 15.0006Z" />
        </svg>
    );
};

export default ArrowDownLineIcon;
